var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown-search-wrap" }, [
    _c("h4", { staticClass: "text-block-title" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("CONTACT_PANEL.LABELS.LABEL_SELECT.TITLE")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search-wrap" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search,
            expression: "search"
          }
        ],
        ref: "searchbar",
        staticClass: "search-input",
        attrs: {
          type: "text",
          autofocus: "true",
          placeholder: _vm.$t("CONTACT_PANEL.LABELS.LABEL_SELECT.PLACEHOLDER")
        },
        domProps: { value: _vm.search },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.search = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "list-wrap" }, [
      _c(
        "div",
        { staticClass: "list" },
        [
          _c(
            "woot-dropdown-menu",
            _vm._l(_vm.filteredActiveLabels, function(label) {
              return _c("label-dropdown-item", {
                key: label.title,
                attrs: {
                  title: label.title,
                  color: label.color,
                  selected: _vm.selectedLabels.includes(label.title)
                },
                on: {
                  click: function($event) {
                    return _vm.onAddRemove(label)
                  }
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _vm.noResult
            ? _c("div", { staticClass: "no-result" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("CONTACT_PANEL.LABELS.LABEL_SELECT.NO_RESULT")
                    ) +
                    "\n      "
                )
              ])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }